import { Component } from 'react';
import { connect } from 'react-redux';

import { Button, Pane } from 'evergreen-ui';
import { Link } from 'react-router-dom';
import DataTable from '../../common/DataTable/DataTable';
import { getShortUrls } from '../actions/ShortUrlActions';

class ListShortUrls extends Component {
    handleTableChange = (opts) => {
        this.props.dispatch(getShortUrls(opts));
    }

    render() {
        return (<>
            <Pane display="flex" marginBottom={16}>
                <Pane>
                    <Link to="/short-urls/create">
                        <Button iconBefore="add" intent="none" appearance="primary">
                            Short URL nou
                        </Button>
                    </Link>
                </Pane>
            </Pane>
            <DataTable
                defaultFilter='id'
                defaultDirection='desc'
                columns={[
                    {id: 'id', label: 'Id'},
                    {id: 'originalUrl', label: 'URL Original'},
                    {id: 'shortCode', label: 'Cod Scurt'},
                    {id: 'clicks', label: 'Accesări'},
                    {id: 'createdAt', label: 'Creat', decorator: 'date'},
                    {id: 'updatedAt', label: 'Updated', decorator: 'date'}
                ]}

                data={this.props.data}

                onTableChange={this.handleTableChange}
                updateKey={this.props.data}
                page={this.props.page}
                pageSize={this.props.pageSize}
                pageCount={this.props.pageCount}

                itemMenu={[
                    { getLink: (item) => `/short-urls/${item[0]}`, label: 'Detalii', icon: 'eye-open' },
                    { getLink: (item) => `/short-urls/${item[0]}/edit`, label: 'Editeaza', icon: 'edit' }
                ]}
            />
        </>)
    }
}

function mapStateToProps(state) {
    return state.shortUrls;
}

export default connect(mapStateToProps)(ListShortUrls);
